import {
  IPI_ST_OPTIONS,
  PIS_ST_OPTIONS,
  COFINS_ST_OPTIONS,
  ICMS_CST_OPTIONS
} from '../../constants/tax-constants'
import { getNCMValidationRules } from '../../utils/ncm-helpers'

export const TaxRulesTable = ({
  register,
  errors,
  isCreatingNCM = false
}) => {

  return (
    <div>
      <h5 className="text-sm font-medium text-gray-700 mb-3">
        Regras Tributárias {isCreatingNCM && '*'}
      </h5>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-gray-300 rounded-md">
          <thead>
            <tr className="bg-gray-50">
              <th className="border border-gray-300 px-3 py-2 text-left font-medium">Campo</th>
              <th className="border border-gray-300 px-3 py-2 text-center font-medium">Contribuinte</th>
              <th className="border border-gray-300 px-3 py-2 text-center font-medium">Não Contribuinte</th>
              <th className="border border-gray-300 px-3 py-2 text-center font-medium">Envio de Estoque</th>
            </tr>
          </thead>
          <tbody>
            {/* IPI ST Entrada */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">IPI ST Entrada</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_ipi_st_entrada', getNCMValidationRules('contribuinte_ipi_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_ipi_st_entrada', getNCMValidationRules('nao_contribuinte_ipi_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_ipi_st_entrada', getNCMValidationRules('envio_ipi_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            {/* IPI ST Saída */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">IPI ST Saída</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_ipi_st_saida', getNCMValidationRules('contribuinte_ipi_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_ipi_st_saida', getNCMValidationRules('nao_contribuinte_ipi_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_ipi_st_saida', getNCMValidationRules('envio_ipi_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {IPI_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">IPI Alíquota (%)</td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('contribuinte_ipi_aliquota', getNCMValidationRules('contribuinte_ipi_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="330"
                    placeholder="0.00"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.contribuinte_ipi_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.contribuinte_ipi_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('nao_contribuinte_ipi_aliquota', getNCMValidationRules('nao_contribuinte_ipi_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="330"
                    placeholder="0.00"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.nao_contribuinte_ipi_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.nao_contribuinte_ipi_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('envio_ipi_aliquota', getNCMValidationRules('envio_ipi_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="330"
                    placeholder="0.00"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.envio_ipi_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.envio_ipi_aliquota.message}</p>
                )}
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">IPI Cod. Enq.</td>
              <td className="border border-gray-300 px-2 py-2">
                <input
                  {...register('contribuinte_ipi_cod_enq', getNCMValidationRules('contribuinte_ipi_cod_enq', isCreatingNCM))}
                  type="text"
                  maxLength="3"
                  placeholder="999"
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.contribuinte_ipi_cod_enq && (
                  <p className="mt-1 text-xs text-red-600">{errors.contribuinte_ipi_cod_enq.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <input
                  {...register('nao_contribuinte_ipi_cod_enq', getNCMValidationRules('nao_contribuinte_ipi_cod_enq', isCreatingNCM))}
                  type="text"
                  maxLength="3"
                  placeholder="999"
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.nao_contribuinte_ipi_cod_enq && (
                  <p className="mt-1 text-xs text-red-600">{errors.nao_contribuinte_ipi_cod_enq.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <input
                  {...register('envio_ipi_cod_enq', getNCMValidationRules('envio_ipi_cod_enq', isCreatingNCM))}
                  type="text"
                  maxLength="3"
                  placeholder="999"
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {errors.envio_ipi_cod_enq && (
                  <p className="mt-1 text-xs text-red-600">{errors.envio_ipi_cod_enq.message}</p>
                )}
              </td>
            </tr>

            {/* PIS ST Entrada */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">PIS ST Entrada</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_pis_st_entrada', getNCMValidationRules('contribuinte_pis_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_pis_st_entrada', getNCMValidationRules('nao_contribuinte_pis_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_pis_st_entrada', getNCMValidationRules('envio_pis_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            {/* PIS ST Saída */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">PIS ST Saída</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_pis_st_saida', getNCMValidationRules('contribuinte_pis_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_pis_st_saida', getNCMValidationRules('nao_contribuinte_pis_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_pis_st_saida', getNCMValidationRules('envio_pis_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {PIS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">PIS Alíquota (%)</td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('contribuinte_pis_aliquota', getNCMValidationRules('contribuinte_pis_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    placeholder="1.65"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.contribuinte_pis_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.contribuinte_pis_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('nao_contribuinte_pis_aliquota', getNCMValidationRules('nao_contribuinte_pis_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    placeholder="0.65"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.nao_contribuinte_pis_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.nao_contribuinte_pis_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('envio_pis_aliquota', getNCMValidationRules('envio_pis_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="10.65"
                    placeholder="2.10"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.envio_pis_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.envio_pis_aliquota.message}</p>
                )}
              </td>
            </tr>

            {/* COFINS ST Entrada */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">COFINS ST Entrada</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_cofins_st_entrada', getNCMValidationRules('contribuinte_cofins_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_cofins_st_entrada', getNCMValidationRules('nao_contribuinte_cofins_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_cofins_st_entrada', getNCMValidationRules('envio_cofins_st_entrada', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            {/* COFINS ST Saída */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">COFINS ST Saída</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_cofins_st_saida', getNCMValidationRules('contribuinte_cofins_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_cofins_st_saida', getNCMValidationRules('nao_contribuinte_cofins_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_cofins_st_saida', getNCMValidationRules('envio_cofins_st_saida', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {COFINS_ST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">COFINS Alíquota (%)</td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('contribuinte_cofins_aliquota', getNCMValidationRules('contribuinte_cofins_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="100"
                    placeholder="7.60"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.contribuinte_cofins_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.contribuinte_cofins_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('nao_contribuinte_cofins_aliquota', getNCMValidationRules('nao_contribuinte_cofins_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="10.65"
                    placeholder="3.00"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.nao_contribuinte_cofins_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.nao_contribuinte_cofins_aliquota.message}</p>
                )}
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <div className="relative">
                  <input
                    {...register('envio_cofins_aliquota', getNCMValidationRules('envio_cofins_aliquota', isCreatingNCM))}
                    type="number"
                    step="0.01"
                    min="0"
                    max="10.65"
                    placeholder="9.65"
                    className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                </div>
                {errors.envio_cofins_aliquota && (
                  <p className="mt-1 text-xs text-red-600">{errors.envio_cofins_aliquota.message}</p>
                )}
              </td>
            </tr>

            {/* ICMS */}
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">ICMS CST Fora Estado</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_icms_cst_outsite', getNCMValidationRules('contribuinte_icms_cst_outsite', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_icms_cst_outsite', getNCMValidationRules('nao_contribuinte_icms_cst_outsite', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_icms_cst_outsite', getNCMValidationRules('envio_icms_cst_outsite', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-50">ICMS CST Dentro Estado</td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('contribuinte_icms_cst_inside', getNCMValidationRules('contribuinte_icms_cst_inside', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('nao_contribuinte_icms_cst_inside', getNCMValidationRules('nao_contribuinte_icms_cst_inside', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
              <td className="border border-gray-300 px-2 py-2">
                <select
                  {...register('envio_icms_cst_inside', getNCMValidationRules('envio_icms_cst_inside', isCreatingNCM))}
                  className="w-full text-sm px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  {ICMS_CST_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Seção opcional - ICMS Redução Base */}
      <div className="mt-6">
        <div className="flex items-center gap-2 mb-3">
          <h6 className="text-sm font-medium text-gray-700 mb-0">
            ICMS Redução Base (%)
          </h6>
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
            Opcional
          </span>
        </div>
        <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md">
          <p className="text-xs text-blue-700 mb-0">
            <strong>Aplicável apenas para movimentações de São Paulo para São Paulo</strong>
          </p>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm border border-gray-300 rounded-md bg-gray-50">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-3 py-2 text-left font-medium">Campo</th>
                <th className="border border-gray-300 px-3 py-2 text-center font-medium">Contribuinte</th>
                <th className="border border-gray-300 px-3 py-2 text-center font-medium">Não Contribuinte</th>
                <th className="border border-gray-300 px-3 py-2 text-center font-medium">Envio de Estoque</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-3 py-2 font-medium bg-gray-100">ICMS Redução Base (%)</td>
                <td className="border border-gray-300 px-2 py-2">
                  <div className="relative">
                    <input
                      {...register('contribuinte_icms_reduction', getNCMValidationRules('contribuinte_icms_reduction', false))}
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="0.00"
                      className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                  </div>
                  {errors.contribuinte_icms_reduction && (
                    <p className="mt-1 text-xs text-red-600">{errors.contribuinte_icms_reduction.message}</p>
                  )}
                </td>
                <td className="border border-gray-300 px-2 py-2">
                  <div className="relative">
                    <input
                      {...register('nao_contribuinte_icms_reduction', getNCMValidationRules('nao_contribuinte_icms_reduction', false))}
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="0.00"
                      className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                  </div>
                  {errors.nao_contribuinte_icms_reduction && (
                    <p className="mt-1 text-xs text-red-600">{errors.nao_contribuinte_icms_reduction.message}</p>
                  )}
                </td>
                <td className="border border-gray-300 px-2 py-2">
                  <div className="relative">
                    <input
                      {...register('envio_icms_reduction', getNCMValidationRules('envio_icms_reduction', false))}
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      placeholder="0.00"
                      className="w-full text-sm px-2 py-1 pr-6 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-gray-500">%</span>
                  </div>
                  {errors.envio_icms_reduction && (
                    <p className="mt-1 text-xs text-red-600">{errors.envio_icms_reduction.message}</p>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
} 